module.exports = __webpack_public_path__ + "fonts/Material-Icons-Outlined.76845a96.woff2";